import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-add-tax',
  templateUrl: './confirm-add-tax.component.html',
  styleUrls: ['./confirm-add-tax.component.scss']
})
export class ConfirmAddTaxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
